export default __webpack_public_path__ + "static/media/uts.52994a80.svg";